module.exports = __webpack_public_path__ + "static/media/calendar.473e275e.svg";